import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { closeicon, erroricon } from "assets/icons/index";
import { useDispatch, useSelector } from "react-redux";
import { setQuickDonatePopStateAction } from "redux/actions/QuickDonatePopActions/setQuickDonatePopStateActions";
import { useTranslation } from "react-i18next";
import { RootState } from "redux/rootReducer";
import { Spin } from "antd";
import { useQuickDonateFormik } from "Forms/quickDonateFormik";

interface QuickDonatePopUpProps {}

const QuickDonatePopUp = ({}: QuickDonatePopUpProps) => {
  const { t, i18n } = useTranslation();
  const dispatch: any = useDispatch();

  const [country, setCountry] = useState("");

  const { quickDonateLoading, quickDonateData } = useSelector(
    (state: RootState) => state.quickDonateReducer
  );

  const { requestSecureUrlLoading } = useSelector(
    (state: RootState) => state.requestSecureUrlReducer
  );

  const { loginData } = useSelector((state: RootState) => state.loginReducer);

  const formik = useQuickDonateFormik(country, quickDonateData);

  return (
    <section
      data-aos="zoom-out"
      data-aos-duration="300"
      className="fixed top-0 left-0 z-[50] w-full h-screen bg-black/70 flex items-center justify-center px-[20px]"
    >
      <Spin spinning={quickDonateLoading}>
        <div className="md:w-[424px] p-[25px] bg-white rounded-[20px] flex flex-col gap-[35px]">
          <div className="w-full flex items-center justify-between">
            <p
              className={`font-${
                i18n.language === "en" ? "Poppins" : "Almarai"
              } font-[600] text-[24px] text-second_color text-center`}
            >
              {t("Quick Donation")}
            </p>

            <img
              onClick={() => dispatch(setQuickDonatePopStateAction(false))}
              className="cursor-pointer"
              src={closeicon}
              alt=""
            />
          </div>

          {/*  form  */}
          <form
            onSubmit={formik.handleSubmit}
            className="flex flex-col gap-[16px]"
          >
            {/* phone number section  */}
            {!loginData && (
              <div>
                <PhoneInput
                  inputStyle={{
                    width: "100%",
                    height: "48px",
                    borderRadius: "10px",
                  }}
                  country={"ae"}
                  countryCodeEditable={false}
                  enableSearch={true}
                  onChange={(phone, x, y, valueseparated) => {
                    // the country code
                    const countryCode = valueseparated.split(" ").shift();
                    formik.setFieldValue("countryCode", countryCode);

                    if (countryCode === "+20") {
                      setCountry("eg");
                    } else if (countryCode === "+971") {
                      setCountry("uae");
                    }
                    const countryCodeLength = countryCode
                      ?.split("")
                      .filter((item: any, idx: number) => idx !== 0)
                      .join("").length;

                    // phone number
                    const phoneNumber = phone.slice(
                      countryCodeLength,
                      phone.length
                    );
                    formik.setFieldValue("phone", phoneNumber);
                  }}
                />

                {formik.errors.phone && (
                  <p
                    className={`mt-[5px] font-${
                      i18n.language === "en" ? "Poppins" : "Almarai"
                    } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                  >
                    <img className="max-w-[18px]" src={erroricon} alt="" />
                    {formik.errors.phone}
                  </p>
                )}
              </div>
            )}

            {/* amount section  */}
            <div className="flex flex-col ">
              <input
                type="number"
                placeholder={t("Amount")}
                name="amount"
                onChange={formik.handleChange}
                className={`w-full h-[48px] rounded-[10px] ${
                  i18n.language === "en"
                    ? "font-Poppins pl-[24px]"
                    : "font-Almarai pr-[24px]"
                } font-[400] text-[16px] text-[#707070] border border-[#B6B6B6] `}
              />

              {formik.errors.amount && (
                <p
                  className={`mt-[5px] font-${
                    i18n.language === "en" ? "Poppins" : "Almarai"
                  } font-[600] text-[12px] text-red-600 flex items-center gap-2`}
                >
                  <img className="max-w-[18px]" src={erroricon} alt="" />
                  {formik.errors.amount}
                </p>
              )}
            </div>

            {/* Donate button  */}
            <Spin spinning={requestSecureUrlLoading}>
              <button
                type="submit"
                className={`mt-[20px] w-full h-[48px] bg-first_color rounded-[10px] text-white font-${
                  i18n.language === "en" ? "Poppins" : "Almarai"
                } font-[600] text-[16px]`}
              >
                {t("Donate")}
              </button>
            </Spin>
          </form>
        </div>
      </Spin>
    </section>
  );
};

export default QuickDonatePopUp;
